import { useQuestBoardQuery } from "../../../networking/queries"
import { getMondayOfWeek, isCoachQuest } from "../../../util/util"

const useCoachRoutineQuests = () => {
  const mondayOfWeek = getMondayOfWeek()
  const { data: questsMonday, isLoading: isLoadingMonday } = useQuestBoardQuery(
    mondayOfWeek.format("YYYY-MM-DD")
  )
  const { data: questsTuesday, isLoading: isLoadingTuesday } =
    useQuestBoardQuery(mondayOfWeek.add(1, "day").format("YYYY-MM-DD"))
  const { data: questsWednesday, isLoading: isLoadingWednesday } =
    useQuestBoardQuery(mondayOfWeek.add(2, "day").format("YYYY-MM-DD"))
  const { data: questsThursday, isLoading: isLoadingThursday } =
    useQuestBoardQuery(mondayOfWeek.add(3, "day").format("YYYY-MM-DD"))
  const { data: questsFriday, isLoading: isLoadingFriday } = useQuestBoardQuery(
    mondayOfWeek.add(4, "day").format("YYYY-MM-DD")
  )
  const { data: questsSaturday, isLoading: isLoadingSaturday } =
    useQuestBoardQuery(mondayOfWeek.add(5, "day").format("YYYY-MM-DD"))
  const { data: questsSunday, isLoading: isLoadingSunday } = useQuestBoardQuery(
    mondayOfWeek.add(6, "day").format("YYYY-MM-DD")
  )

  const coachRoutineQuests = [
    ...(questsMonday?.filter((quest) => isCoachQuest(quest)) || []),
    ...(questsTuesday?.filter((quest) => isCoachQuest(quest)) || []),
    ...(questsWednesday?.filter((quest) => isCoachQuest(quest)) || []),
    ...(questsThursday?.filter((quest) => isCoachQuest(quest)) || []),
    ...(questsFriday?.filter((quest) => isCoachQuest(quest)) || []),
    ...(questsSaturday?.filter((quest) => isCoachQuest(quest)) || []),
    ...(questsSunday?.filter((quest) => isCoachQuest(quest)) || []),
  ]

  return {
    coachRoutineQuests,
    isLoading:
      isLoadingMonday ||
      isLoadingTuesday ||
      isLoadingWednesday ||
      isLoadingThursday ||
      isLoadingFriday ||
      isLoadingSaturday ||
      isLoadingSunday,
  }
}

export default useCoachRoutineQuests
